import storageService from "@/services/storage.service";
import axiosInstance from "./api";
import firebaseService from "@/services/firebase.service";
import utilService from "@/services/util.service";
import { TYPE } from "vue-toastification";
import { getValidKeycloakToken, hasKeycloakConfig } from "@/lib/keycloak";
import { markAccountBannedSession, clearAccountBannedSession, isAccountBannedSession } from "@/helpers/accountBannedSession";
import {
  markAccountDeletedSession,
  clearAccountDeletedSession,
  isAccountNotFoundApiError,
  isAccountDeletedSession,
  isAllowedDuringAccountDeletedSession,
} from "@/helpers/accountDeletedSession";

const setup = (router: any) => {
  axiosInstance.interceptors.request.use(
    async (config) => {
      // Check if we're in logout flow and cancel new requests
      if (utilService.isInLogoutFlow()) {
        return Promise.reject(new Error("Request cancelled due to session expiry"));
      }
      if (isAccountBannedSession()) {
        const url = String(config.url || "");
        if (!url.includes("users/me")) {
          return Promise.reject(
            new Error("Request cancelled: restricted account session")
          );
        }
      }
      if (isAccountDeletedSession()) {
        const url = String(config.url || "");
        if (!isAllowedDuringAccountDeletedSession(url)) {
          return Promise.reject(
            new Error("Request cancelled: restricted account session")
          );
        }
      }

      if (config.headers === undefined) {
        //@ts-ignore
        config.headers = {};
      }
      let token = storageService.getToken();
      if (hasKeycloakConfig()) {
        const keycloakToken = await getValidKeycloakToken();
        if (keycloakToken) {
          token = keycloakToken;
          storageService.setToken(keycloakToken);
        }
      }
      const sessionId = storageService.getSessionId();
      const user = storageService.getUser();
      const isFirebaseLogin = storageService.getIsFirebaseLogin();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      if (user && user._id) {
        config.headers["UserId"] = user._id;
      }

      const currentDate = new Date();
      const utcOffsetMinutes = currentDate.getTimezoneOffset();
      const utcOffsetHours = utcOffsetMinutes / 60;
      config.headers["offsettimezone"] = utcOffsetHours.toString();
      config.headers["NewRoute"] = storageService.GetProperty("newRoute");
      config.headers["OldRoute"] = storageService.GetProperty("oldRoute");
      config.headers["sessionid"] = sessionId
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      const url = String(res.config?.url || "");
      const method = String(res.config?.method || "get").toLowerCase();
      if (method === "get" && url.includes("users/me") && res.status === 200) {
        clearAccountBannedSession();
        clearAccountDeletedSession();
      }
      return res;
    },
    async (err) => {
      // Don't process errors if we're already in logout flow
      if (utilService.isInLogoutFlow()) {
        return Promise.reject(err);
      }

      const originalConfig = err.config;

      if (originalConfig?.url) {
        const u = String(originalConfig.url);
        if (u.includes("users/me")) {
          if (err.response?.status === 403) {
            markAccountBannedSession();
            clearAccountDeletedSession();
            storageService.RemoveAllProperties();
            if (router.currentRoute.value?.name !== "accountBanned") {
              router.replace({ name: "accountBanned" }).catch(() => {});
            }
            return Promise.reject(err);
          }
          if (isAccountNotFoundApiError(err)) {
            markAccountDeletedSession();
            clearAccountBannedSession();
            storageService.RemoveAllProperties();
            if (router.currentRoute.value?.name !== "accountDeleted") {
              router.replace({ name: "accountDeleted" }).catch(() => {});
            }
            return Promise.reject(err);
          }
        }
      }

      if (!originalConfig?.url?.includes("auth") && err.response) {
        if (err.response.status == 401 && originalConfig) {
          // storageService.RemoveAllProperties();
          // location.reload();
          // await firebaseService.getAuthToken();
          // err.config.__isRetryRequest = true;
          // let firebaseToken = storageService.getToken();
          // err.config.headers.token = `Firebase ${firebaseToken}`;
          // return axiosInstance(err.config);
          
          // Don't trigger multiple 401 errors
          if (!utilService.isInLogoutFlow()) {
            if (!isAccountBannedSession() && !isAccountDeletedSession()) {
              utilService.handle401Error();
            }
          }
        }
      }

      return Promise.reject(err);
    }
  );
};

export default setup;
